<!-- 监控平台 列表 搜索条件下面的半定制组件 -->
<template>
    <div class="monitorPlatformList"
         v-if="tableName == 'OC_B_ORDER_LOG'">
      <template v-for="(it, index) in config">
        <div :key="index"
             class="item">
          <img :src="it.img"
               alt="" />
          <div>
            <p>{{ it.sum }}</p>
            <span>{{ it.desc }}</span>
          </div>
        </div>
      </template>
    </div>
    <!--异常预警-->
    <div v-else-if="tableName === 'OC_B_RETURN_ORDER_WARNING'">
      <returnOrderWarning />
    </div>
    <!-- 库存模型查询 -->
    <div v-else-if="tableName === 'INVENTORY_MODEL_QUERY'">
      <checkInventoryModel />
    </div>
    <!-- 库存模型查询 -->
    <div v-else-if="tableName === 'PS_C_PRO_SN'" v-show="data1.length" :style="{top:`${standardTableTop}px`}" class="CUSTOM_PS_C_PRO_SN">
      <Table height="300" :columns="columns1" :data="data1"></Table>
    </div>
    <div v-else-if="isPermission" class="permission" style="order: 50">
      <span>*</span>{{ t('当前过滤设置') }}：
      <span>{{ conds }}</span>
    </div>
    <div v-else-if="tableName === 'SG_B_CHANNEL_PRODUCT' || tableName === 'SG_B_SA_STORAGE'" class="channelProductWarning">
      ⚠️ 库存≤5的热卖品，建议关闭库存同步。或者在“平台店铺商品”设置安全库存，≤安全库存时，系统将自动关闭库存同步。
    </div>
    <!--发票单管理-->
<!--    <div v-if="tableName === 'AC_F_ORDER_INVOICE'">-->
<!--      <orderInvoice />-->
<!--    </div>-->

</template>

<script>
import returnOrderWarning from '@/views/pages/orderCenter/returnOrderWarning/returnOrderWarning';
import orderInvoice from '@/views/pages/financeCenter/orderInvoice/orderInvoice';
import checkInventoryModel from '@/views/modal/inventoryCenter/checkInventoryModel.vue';
import interceptorsModule from '@/config/interceptors'

export default {
  inheritAttrs: true,
  components: {
    returnOrderWarning,
    orderInvoice,
    checkInventoryModel
  },
  data() {
    return {
      standardTableTop: 0,
      columns1: [
        {
          type: 'index',
          title: t('序号'),
        },
        {
          title: t('SN码'),
          key: 'sn_ecode'
        },
        {
          title: t('状态'),
          key: 'sn_status'
        }
      ],
      data1: [],
      config: [
        {
          img: "https://avatars1.githubusercontent.com/u/31434913?s=460&v=4",
          sum: 888,
          desc: '总数',
        },
        {
          img: "https://qywechat.s3.cn-northwest-1.amazonaws.com.cn/07ei77-%E7%BB%84%203225%402x.png",
          sum: 888,
          desc: '总数',
        },
        {
          img: "https://avatars1.githubusercontent.com/u/31434913?s=460&v=4",
          sum: 888,
          desc: '总数',
        },
        {
          img: "https://avatars1.githubusercontent.com/u/31434913?s=460&v=4",
          sum: 888,
          desc: '总数',
        },
      ],
      conds: '',
    }
  },
  watch: {
    '$store.state.omsStore.PS_C_PRO_SN_CUSTOM_TABLE_DATA': {
      handler(val) {
        // console.log(val)
        this.data1 = val
      },
      immediate: true
    },
    fixedcolumns: {
      handler(val, old) {
        if (val) {
          console.log('watch fixedcolumns', val)
          setTimeout(() => {
            $utils.getFixedcolumns().then(res => {
              console.log('conds', res)
              const newDate = interceptorsModule.permission.definedVal(res)
              newDate && (this.conds = newDate.map(i => `(${i.label})`).join(` ${t('并且')} `))
            })
          }, 1000)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    tableName() {
      return this.$store.state.global.activeTab.tableName
    },
    isPermission() {
      return interceptorsModule.permission.isPermission()
    },
    fixedcolumns() {
      return this.$store.state[R3.getModuleName()] && this.$store.state[R3.getModuleName()].fixedcolumns
    }
  },
  mounted() {
    setTimeout(() => {
      this.standardTableTop = $('.standardTable').position().top
    }, 1000);
  },
  beforeDestroy() {
    console.log('standardTableListdefind::beforeDestroy::');
    vm.$store.commit("omsStore/up_PS_C_PRO_SN_CUSTOM_TABLE_DATA", []);
  }
}
</script>

<style lang="less" scoped>
.monitorPlatformList {
  display: grid;
  grid-template-columns: repeat(4, minmax(200px, 2fr));
  grid-gap: 0 25px;
  padding: 12px 10px 0;
  .item {
    display: flex;
    justify-content: space-around;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    min-width: 200px;
    min-height: 100px;
    img {
      height: 80px;
    }
    p {
      height: 32px;
      line-height: 32px;
      font-size: 26px;
      font-weight: bold;
    }
    span {
      // text-align: right;
      height: 24px;
      line-height: 24px;
      float: right;
    }
  }
}
</style>

<style lang="less">
.channelProductWarning {
  color: red;
  margin: 0 12px !important;
  font-size: 14px;
  background-color: #fff;
  padding: 0 8px 8px;
  order: 21;
}
#PS_C_PRO_SN {
  .CUSTOM_PS_C_PRO_SN {
    position: absolute;
    right: 24px;
    top: 30%;
  }
  .standardTable {
    width: 66vw;
  }
}
</style>
<style lang="less" scoped>
.permission {
  margin: 0 8px 8px;
  span:first-child {
    color: red;
  }
}
</style>
